export const makeCartDataJsonString = (data, discountCode = null) => {
    let jsonString = {
        domain_id: data.domain_id,
        products: { ...data.quantities },
        discount_code: (discountCode ? discountCode.code : ""),
    }
    return JSON.stringify(jsonString);
}

export const removeItem = (sessionCartData, itemId) => {
    delete sessionCartData[itemId];
    return sessionCartData;
}
 export const removeCourseEventGoogleAnalytics =  (item) => {
     if(typeof window !== "undefined" && window.dataLayer && item) {
         window.dataLayer.push({
             event: "remove_item",
             ecommerce: {
                 currency: "USD",
                 value:item.unit_cost,
                 items: [
                     {
                         title: item.title,
                         brand_name: item.brand_name || 'mindedge',
                         product_type: (item.course_id.includes('suite')? 'suite': 'course'),
                         category: item.category || 'none provided',
                         list_price: item.unit_cost,
                     }
                 ]
             }
         });
     }
 }
export const countItems = (purchaseApp) => {
    let totalItems = 0;

    if (purchaseApp.quantities) {
        let itemIds = Object.keys(purchaseApp.quantities)
        totalItems = itemIds.map((item) => purchaseApp.quantities[item])
            .reduce((acc, cur) => acc + cur)
    }
    return totalItems;
}

export const updateCartUIElement = (num) => {
    let itemEl = document.querySelector('.cart-items-number');
    let numItems = num < 1 ? 0 : num;
    /* Original code line */
    //itemEl.textContent = numItems + ((numItems > 1 || numItems == 0) ? ' Items' : ' Item');
    /* Removing count label for new Navigatation 2020 */
    itemEl.textContent = numItems;
}

export const shouldDisableCheckoutButton = (items) => {
    return items > 0 ? false : true;
}

export const formatMoney = (number, decimals, dec_point, thousands_sep) => {
    number = +number;
    const str = number.toFixed(decimals ? decimals : 0).toString().split('.');
    let parts = [];
    for (let i = str[0].length; i > 0; i -= 3) {
        parts.unshift(str[0].substring(Math.max(0, i - 3), i));
    }
    str[0] = parts.join(thousands_sep ? thousands_sep : ',');
    return str.join(dec_point ? dec_point : '.');
};

export const makeProductLink = (product_id, product_title) => {
    const id = product_id.toString(); let link = '';
    if (id.toString().indexOf('suite_') > -1) {
        link = '/suites/' + id.substring(6) + '/' + product_title.toLowerCase().replace(/[^a-zA-Z0-9 -]/g, ' ').replace(/  +/g, ' ').replace(/ /g, '-');
    } else {
        link = '/courses/' + id + '/' + product_title.toLowerCase().replace(/[^a-zA-Z0-9 -]/g, ' ').replace(/  +/g, ' ').replace(/ /g, '-');
    }
    link = removeTrailingHyphen(link);
    return link;
}

export const makeMenuLink = (idValue, title, path) => {
    const id = idValue.toString();
    let link = path + id + '/' + title.toLowerCase().replace(/[^a-zA-Z0-9 -]/g, ' ').replace(/  +/g, ' ').replace(/ /g, '-');
    link = removeTrailingHyphen(link);
    return link;
}

export const removeTrailingHyphen = (value) => {
    return (value[value.length - 1].match('-')) ? value.slice((value[value.length - 2]), value.length - 1) : value;
}


